<template>
  <div class="document-style">
    <ul class="fs-16">
      <li>
        <div>
          <div class="title-list-style">
            <span>Happiness VS Risk Rate</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; the bar graph shows
              historical data of Active User, Happiness and Risk Rate
            </div>
          </div>
          <div class="note-box">
            <div class="">Data Showing</div>
            <div class="mt-4">
              <div>Happiness Rate</div>
              <div>Risk Rate</div>
              <div>Active Users of that time period</div>
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              You can see the
              <span class="fw-700">engagement health</span> chart by open
              details view, this chart tracked engagement health progress by
              dimension by team, so that you can see how changes impact team
              health and outcomes.
            </span>
          </div>
        </div>
      </li>
      <li>
        <div>
          <div class="title-list-style">
            <span>Spotlight</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; A highlight of teams with
              significant data, and should be getting attention
            </div>
          </div>
          <div class="note-box">
            <div class="flex">
              <div class="mt-4" style="width: 140px">
                <div style="color: rgb(76, 175, 80)">Most Engaged:</div>
                <div>&nbsp;</div>
                <div style="color: rgb(255, 193, 7)">Retention Risk:</div>
                <div>&nbsp;</div>
                <div style="color: rgb(33, 150, 243)">Most Improved:</div>
                <div>&nbsp;</div>
                <div style="color: rgb(244, 67, 54)">Most Critical:</div>
              </div>
              <div class="mt-4">
                <div>
                  Teams with highest engagement scores. The score represents an
                  aggregate score from 9-dimensions of engagement.
                </div>
                <div>
                  Teams with highest retention risk scores. The score represents
                  an aggregate from dimensions associated with attrition.
                </div>
                <div>
                  Teams that show the most improvement over the past 2-weeks.
                  The score represents the change increase of engagement scores.
                </div>
                <div>
                  Teams that are most critical over the past 2-weeks. The score
                  represents the change decrease of engagement scores.
                </div>
              </div>
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>Click on each team card to open details view. </span>
          </div>
        </div>
      </li>
      <li>
        <div>
          <div class="title-list-style">
            <span>Team / Cohorts Status:</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; represents score in
              green/yellow/red for each team
            </div>
          </div>
          <div class="note-box">
            <div class="fw-700">
              How to breakdown score into Green / Yellow / Red
            </div>
            <div class="flex">
              <div class="mt-4" style="width: 28px">
                <div
                  style="
                    background-color: #66bb6a;
                    height: 24px;
                    width: 24px;
                    border-radius: 32px;
                  "
                >
                </div>
              </div>
              <div class="mt-4 flex-center">
                <span class="fw-700" style="color: #66bb6a"
                  >More than 75%&nbsp;
                </span>
                <span> of team members answer Good </span>
              </div>
            </div>
            <div class="flex">
              <div class="mt-4" style="width: 28px">
                <div
                  style="
                    background-color: #fbc02d;
                    height: 24px;
                    width: 24px;
                    border-radius: 32px;
                  "
                >
                  &nbsp;
                </div>
              </div>
              <div class="mt-4 flex-center">
                <span class="fw-700" style="color: #fbc02d"
                  >50% - 74%&nbsp;
                </span>
                <span> of team members answer Good </span>
              </div>
            </div>
            <div class="flex">
              <div class="mt-4" style="width: 28px">
                <div
                  style="
                    background-color: #f44336;
                    height: 24px;
                    width: 24px;
                    border-radius: 32px;
                  "
                >
                  &nbsp;
                </div>
              </div>
              <div class="mt-4 flex-center">
                <span class="fw-700" style="color: #f44336"
                  >Less then 50%&nbsp;
                </span>
                <span> of team members answer Good </span>
              </div>
            </div>
            <div class="flex">
              <div class="mt-4 mr-4" style="width: 28px">
                <div
                  style="
                    background-color: #c7c7c7;
                    height: 24px;
                    width: 24px;
                    border-radius: 32px;
                  "
                >
                  &nbsp;
                </div>
              </div>
              <div class="mt-4 flex-center">
                <span
                  >None of the team members answer questions in that
                  dimension, or the questions on that dimension have not yet
                  been sent (in the case of just starting to use Happily)
                </span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
    
  <script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>
    
  <style lang="scss" scoped></style>